document.querySelectorAll('.cp-seeker')?.forEach(seeker => {
    seeker.querySelector('.cp-seeker__input')?.addEventListener('blur', (e: any) => {
        if (e.target.value) e.target.classList.add('cp-seeker__input--valid')
        else e.target.classList.remove('cp-seeker__input--valid')
    })
})